import { FiPlus } from "react-icons/fi";

interface AddButtonProps {
  onClick: () => void;
  tooltip?: string;
  size?: "sm" | "md" | "lg";
  variant?: "primary" | "secondary";
}

export function AddButton({
  onClick,
  tooltip,
  size = "md",
  variant = "primary",
}: AddButtonProps) {
  const sizeClasses = {
    sm: "h-10 w-10",
    md: "h-[52px] w-[52px]",
    lg: "h-14 w-14",
  };

  const iconSizes = {
    sm: 16,
    md: 20,
    lg: 24,
  };

  const variantClasses = {
    primary:
      "bg-gradient-to-br from-[#92C163] to-[#7FB350] hover:from-[#A4C880] hover:to-[#92C163] text-white shadow-md hover:shadow-lg",
    secondary:
      "bg-white border-2 border-dashed border-[#0085BD] text-[#0085BD] hover:bg-[#0085BD]/5 hover:border-solid",
  };

  return (
    <button
      type="button"
      onClick={onClick}
      title={tooltip}
      className={`
        ${sizeClasses[size]}
        ${variantClasses[variant]}
        rounded-xl
        flex items-center justify-center
        transition-all duration-200
        hover:scale-105 active:scale-95
        focus:outline-none focus:ring-2 focus:ring-[#0085BD] focus:ring-offset-2
        group
      `}
    >
      <FiPlus
        size={iconSizes[size]}
        className="transition-transform duration-200 group-hover:rotate-90"
      />
    </button>
  );
}
